import { render } from "./PretermProductDetail.vue?vue&type=template&id=4efae8de&scoped=true"
import script from "./PretermProductDetail.vue?vue&type=script&lang=js"
export * from "./PretermProductDetail.vue?vue&type=script&lang=js"

import "./PretermProductDetail.vue?vue&type=style&index=0&id=4efae8de&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4efae8de"]])

export default __exports__